import api from '@/api'

const namespaced = true

const state = {
  checklistMonitoring: [],
  checklistFile: {}
}

const getters = {
  checklistMonitoring: state => state.checklistMonitoring,
  checklistFile: state => state.checklistFile
}

const mutations = {
  SET_CHECKLIST_MONITORING: (state, payload) => {
    state.checklistMonitoring = payload
  },
  SET_CHECKLIST_FILE: (state, payload) => {
    state.checklistFile = payload
  }
}

const actions = {
  async fetchChecklistMonitoring({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']

      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }

      const { data } = await api.getChecklistMonitoring(filter)
      if (data.error) {
        commit('SET_CHECKLIST_MONITORING', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_CHECKLIST_MONITORING', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async exportChecklistMonitoring({ commit }, payload) {
    try {
      const data = await api.getChecklistMonitoringExport( payload )
      if (data) {
        commit('SET_CHECKLIST_FILE', data)
      }
      return data
    } catch (err) {
      throw err
    }
  },
  resetFileExport({ commit }) {
    commit('SET_CHECKLIST_FILE', {})
  }
}

export default { namespaced, state, getters, mutations, actions }